import axios from '@axios'

export default {
  namespaced: true,
  state: {
    respData: null,
    selectedCategories: [],
  },
  getters: {
  },
  mutations: {
    GET(state, payload) {
      state.respData = payload
    },
    ADD(state, payload) {
      state.respData.data.unshift(payload)
    },
    UPDATE(state, payload) {
      const productIndex = state.respData.data.findIndex(p => p._id === payload._id)
      Object.assign(state.respData.data[productIndex], payload)
    },
    REMOVE(state, id) {
      if (state.respData != null) {
        const ItemIndex = state.respData.data.findIndex(p => p._id === id)
        state.respData.data.splice(ItemIndex, 1)
        // eslint-disable-next-line operator-assignment
        state.respData.max = state.respData.max - 1
      }
    },
    GetCategory(state, items) {
      state.selectedCategories = items
      console.log('selectedCategories ', state.selectedCategories)
    },
    SelectCategory(state, payload) {
      console.log('payload ', payload.position)
      // eslint-disable-next-line no-prototype-builtins
      if (state.selectedCategories.hasOwnProperty(payload.position)) {
        if (state.selectedCategories[payload.position] === payload._id) {
          state.selectedCategories.splice(payload.position)
        } else {
          state.selectedCategories[payload.position] = payload._id
          state.selectedCategories.splice(payload.position + 1)
        }
      } else {
        state.selectedCategories.push(payload._id)
      }
      console.log('selectedCategories ', state.selectedCategories)
    },
    ClearCategory(state, item) {
      state.selectedCategories = []
    },
  },
  actions: {
    get({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/web/application/eCommerce/audioCategory/get?pageSize=${item.pageSize}&currentPage=${item.currentPage}&position=${item.position}&searchQuery=${item.searchQuery}`)
          .then(response => {
            commit('GET', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    add({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.post('/api/web/application/eCommerce/audioCategory/add', item)
          .then(response => {
            // commit('ADD', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    update({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.put('/api/web/application/eCommerce/audioCategory/update', item)
          .then(response => {
            // commit('UPDATE', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    delete({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/web/application/eCommerce/audioCategory/delete?id=${item}`)
          .then(response => {
            commit('REMOVE', item)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    import({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/web/application/eCommerce/audioCategory/import', item)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    // eslint-disable-next-line no-unused-vars
    saveSort({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put('/api/web/application/eCommerce/audioCategory/saveSort', item)
          .then(response => {
            // commit('SWITCH_CHANGE', item)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
